import { type ServiceRequest, serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type { GetNoticeResponse, NoticesApiGetNoticeRequest } from 'viewup-api/v2';

export type GetNoticeReq = ServiceRequest<NoticesApiGetNoticeRequest>;
export type GetNoticeRes = GetNoticeResponse;
export const getNotice = async (req: GetNoticeReq) => {
  const { data: response } = await serviceApi.notice.getNotice(withServiceRequestDefaults(req));
  return response;
};
